import { render } from "./master-board.vue?vue&type=template&id=04721ef1&scoped=true"
import script from "./master-board.vue?vue&type=script&lang=js"
export * from "./master-board.vue?vue&type=script&lang=js"

import "./master-board.vue?vue&type=style&index=0&id=04721ef1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04721ef1"

export default script